import {css} from "lit";


export const styles = css`
  :host {
      display: inline-flex;
      align-items: center;
    }

   sbk-tag {
    margin-right: var(--sbkMultiSelectSpacingNewSelectedLargeGapTags);
   }
`;
